export const formatPrice = (price: number) => price.toLocaleString('GB', { style: 'currency', currency: 'GBP', minimumFractionDigits: 2, maximumFractionDigits: 2 })
